/**
 * External dependecies
 */

const cookie = require('js-cookie');
const jwtDecode = require('jwt-decode');

const cookieName = 'oa_cnt_jwt';

const setAuthToken = (token, name) => cookie.set(`${cookieName}_${name}`, token);

const getAuthToken = name => {
  try {
    return cookie.get(`${cookieName}_${name}`);
  } catch (e) {
    return '';
  }
};
const isAllowSwitchSupplier = () => {
  const decodedJwt = jwtDecode(getAuthToken('id_token'));
  if (decodedJwt['custom:is_allow_switch_sup'] === 'true') {
    return true;
  }
  return false;
};

const removeToken = name => {
  cookie.remove(`${cookieName}_${name}`);
};

module.exports = { getAuthToken, setAuthToken, removeToken, isAllowSwitchSupplier };



// WEBPACK FOOTER //
// ./src/components/authentication/Authentication.js